export interface AppStartupErrorProps {
  error: unknown;
}

/** Rendered when application configuration (`VITE_*` env vars) is missing or invalid, before the router mounts. */
export function AppStartupError({ error }: AppStartupErrorProps) {
  const message =
    error instanceof Error ? error.message : 'Unknown startup error.';

  return (
    <div role="alert" className="app-error">
      <h1>Clara failed to start</h1>
      <p>{message}</p>
    </div>
  );
}
